import React, { useState, useEffect } from 'react';

import { ApiMethodHeader, ExpandIcon, ApiDescription } from './styles';

export default function ApiMethod({ isDarkMode, apiMethod }) {
  const [isOpen, setIsOpen] = useState(false);
  const [canOpen, setCanOpen] = useState(false);

  useEffect(() => setCanOpen(!!apiMethod?.description || !!apiMethod?.challengeDescription), [apiMethod, setCanOpen]);

  return (
    <>
      <ApiMethodHeader canOpen={canOpen} isOpen={isOpen} onClick={() => setIsOpen(canOpen && !isOpen)}>
        {apiMethod.header}
        {canOpen && <ExpandIcon icon={'fa fa-caret-down'} />}
      </ApiMethodHeader>
      {isOpen && (
        <>
          <ApiDescription isDarkMode={isDarkMode}>{apiMethod.description}</ApiDescription>
          {apiMethod.challengeDescription && (
            <ApiDescription isDarkMode={isDarkMode}>{apiMethod.challengeDescription}</ApiDescription>
          )}
        </>
      )}
    </>
  );
}
